<template>
  <div id="app" v-wechat-title="$route.meta && $route.meta.title">
    <toApp v-if="isShowToApp && $route.name != 'detail'"></toApp>
    <transition mode="out-in">
      <!-- 需要缓存的组件都以Alive开头 -->
      <keep-alive :include="/^Alive/">
        <router-view class="view"></router-view>
      </keep-alive>
    </transition>
    <avoidSpider v-if="isShowSpider"></avoidSpider>
  </div>
</template>

<script>
import toApp from "./components/toApp";
import avoidSpider from "./components/avoidSpider";
import getUa from "@/utils/getUa";
export default {
  data() {
    return {
      isShowToApp: !this.$getParam("hideToApp"),
      isxzapp: getUa.userAgent.isxzapp, // 判断是否是小猪app
    };
  },
  components: {
    // Loading,
    toApp,
    avoidSpider,
  },
  computed: {
    isShowSpider() {
      return this.$store.state.needsCheck;
    },
  },
  created() {
    if (!this.getCookie("userInfo")) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("xzuser");
      localStorage.removeItem("hadLog");
    }
    // 航空管家入口隐藏 app
    if((this.$getParam("source") && this.$getParam("source") === 'aviationButler') || (this.getCookie("source") && this.getCookie("source") === 'aviationButler')) {
      this.isShowToApp = false;
    }
  },
  mounted() {
    // 如果设置了  用户一段时间内无操作，自动退出登录功能 非登录注册页面
    if (
      logoutLimit &&
      this.$route.name != "login" &&
      this.$route.name != "register" &&
      !this.isxzapp
    ) {
      // 超时登出
      let logoutTimer = setTimeout(this.logout, logoutTime);
      // 设定定时器
      const userOpDelay = () => {
        clearTimeout(logoutTimer);
        logoutTimer = setTimeout(this.logout, logoutTime);
      };
      this.addEvent(document.getElementById("app"), "keydown", function (e) {
        userOpDelay();
      });
      this.addEvent(document.getElementById("app"), "keyup", function (e) {
        userOpDelay();
      });
      this.addEvent(document.getElementById("app"), "touch", function (e) {
        userOpDelay();
      });
      this.addEvent(document.getElementById("app"), "click", function (e) {
        userOpDelay();
      });
      this.addEvent(document.getElementById("app"), "scroll", function (e) {
        userOpDelay();
      });
      if(this.$route.name === "login" || this.$route.name === "register"){
            this.isShowToApp = true
            this.$forceUpdate()
        }

    }
  },
  methods: {
    logout() {
      // 清除所有缓存 重新登录
      localStorage.clear();
      this.deleteCookie("userInfo");
      this.$router.push("/login");
    },
    getCookie(name) {
      let arr;
      const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    addEvent(obj, ev, fn) {
      // obj为要绑定事件的元素，ev为要绑定的事件，fn为绑定事件的函数
      if (obj.addEventListener) {
        obj.addEventListener(ev, fn, false);
      } else if (obj.attachEvent) {
        obj[ev + fn] = function () {
          fn.call(obj);
        };
        obj.attachEvent("on" + ev, obj[ev + fn]);
      } else {
        obj["on" + type] = fn;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style/style";
</style>



// WEBPACK FOOTER //
// src/App.vue